export const acData = [{
        "id": "1",
        "product": "Air Conditioner",
        "image": "/assets/Ac/1.jpg",
        "company": "LG",
        "model": "CoolTech 5000",
        "price": "799.99",
        "category": "Electronics",
        "description": "Powerful 15000 BTU window air conditioner with energy-saving features."
    },
    {
        "id": "2",
        "product": "AC Unit",
        "image": "/assets/Ac/2.jpg",
        "company": "Daikin",
        "model": "ClimateMaster Pro",
        "price": "1299.00",
        "category": "Electronics",
        "description": "Advanced split-system AC with smart temperature control and quiet operation."
    },
    {
        "id": "3",
        "product": "Cooling System",
        "image": "/assets/Ac/3.jpg",
        "company": "Carrier",
        "model": "Arctic Breeze 300",
        "price": "899.99",
        "category": "Electronics",
        "description": "Ductless mini-split AC with adjustable airflow and dehumidification."
    },
    {
        "id": "4",
        "product": "Air Cooler",
        "image": "/assets/Ac/4.jpg",
        "company": "Honeywell",
        "model": "FrostFlow XL",
        "price": "299.50",
        "category": "Electronics",
        "description": "Portable evaporative cooler with large water tank for efficient cooling in dry climates."
    },
    {
        "id": "5",
        "product": "Window AC",
        "image": "/assets/Ac/5.jpg",
        "company": "Whirlpool",
        "model": "ChillGuard 800",
        "price": "549.00",
        "category": "Electronics",
        "description": "Energy-efficient window-mounted air conditioner with remote control."
    },
    {
        "id": "6",
        "product": "Smart AC",
        "image": "/assets/Ac/6.jpg",
        "company": "Nest",
        "model": "EcoCool Smart+",
        "price": "899.99",
        "category": "Electronics",
        "description": "Wi-Fi connected smart AC that adapts to your cooling preferences and schedule."
    },
    {
        "id": "7",
        "product": "Inverter AC",
        "image": "/assets/Ac/7.jpg",
        "company": "Mitsubishi",
        "model": "SilentComfort 1200i",
        "price": "1499.00",
        "category": "Electronics",
        "description": "Inverter technology AC with precise temperature control and energy efficiency."
    },
    {
        "id": "8",
        "product": "Portable AC",
        "image": "/assets/Ac/8.jpg",
        "company": "Frigidaire",
        "model": "EZCool Portable 400",
        "price": "399.99",
        "category": "Electronics",
        "description": "Easy-to-move portable air conditioner with quick installation and cooling."
    },
    {
        "id": "9",
        "product": "Ducted AC",
        "image": "/assets/Ac/9.jpg",
        "company": "Lennox",
        "model": "PureAir Ducted 6000",
        "price": "2499.00",
        "category": "Electronics",
        "description": "Whole-house ducted AC system with advanced air purification technology."
    },
    {
        "id": "10",
        "product": "Wall-Mount AC",
        "image": "/assets/Ac/10.jpg",
        "company": "Panasonic",
        "model": "WallMaster Pro 1800",
        "price": "749.00",
        "category": "Electronics",
        "description": "Wall-mounted AC with adjustable louvers and energy-saving features."
    },
    {
        "id": "11",
        "product": "Split AC",
        "image": "/assets/Ac/11.jpg",
        "company": "Haier",
        "model": "CoolWave Split 220",
        "price": "649.50",
        "category": "Electronics",
        "description": "High-performance split AC system with rapid cooling and remote control."
    },
    {
        "id": "12",
        "product": "Central AC",
        "image": "/assets/Ac/12.jpg",
        "company": "Trane",
        "model": "ClimateCentral 5000",
        "price": "2999.00",
        "category": "Electronics",
        "description": "Powerful central AC unit for large homes with zone-based temperature control."
    }
]